import { isArray } from '@lhb/func';
import React from 'react';

export interface BasicType {
  children?: React.ReactNode;
  location?: any;
}

export interface IconType {
  iconName: string;
}

export enum HeaderStatus {
  USER_INFO = 'userInfo', // 用户信息
  CHANGE_TENANT = 'changeTenant', // 切换租户
  CHANGE_ACCOUNT = 'changeAccount',
  LOGIN_OUT = 'loginOut',
  EDIT_PASSWORD = 'editPassword',
  RESET_PASSWORD = 'resetPassword',
  MAP_BG_CONFIG = 'mapBgConfig', // 地图底色
}

// 需要收起左侧菜单栏的页面
export const foldUrl = [
  '/iterate/siteselectionmap', // 最新选址地图（第二代）
  '/iterate/siteselectionmapb', // 最新选址地图(b-第三代)
  '/map', // 最新选址地图(b-第三代)-别名
  '/xtc', // 小天才
  '/youth/map', // 选址地图-青春版
];

// 右侧内容区不需要有padding的页面
export const fullContentUrl = [
  '/spotevaluation', // 点位测评
];

// 业务场景，过滤菜单中一级以下的icon不显示，为了保持统一
export function filterTargetLevelIcon(arr: any[], level = 1) {
  arr?.forEach((item: any) => {
    const { children, icon } = item || {};
    if (icon && level > 1) {
      item.icon = null;
    }
    if (isArray(children) && children.length) {
      filterTargetLevelIcon(children, level + 1);
    }
  });
}

// 地图背景色枚举值
export const MapThemeEnum = {
  NORMAL: 'normal', // 标准
  DARK: 'dark', // 幻影黑
  LIGHT: 'light', // 月光银
  WHITESMOKE: 'whitesmoke', // 远山黛
};
// 地图背景色文案枚举值
export const MapThemeLabelEnum = {
  NORMAL: '标准',
  DARK: '幻影黑',
  LIGHT: '月光银',
  WHITESMOKE: '远山黛',
};
